import { defaultAxios, IParams } from './base';

export interface IFetchBaseInfo extends IParams {
  // condition 없음
}

export const fetchBaseInfo = async (params: IFetchBaseInfo) => {
  return await defaultAxios().post(`/base/info`, params);
};
